import { Box, CssBaseline, useColorScheme } from "@mui/material";
import { ThemeContext } from "./ThemeContext";

export default function ThemeComponent({ children }) {
    let { mode, setMode } = useColorScheme();
    if (!mode) return null;

    return (
        <ThemeContext.Provider value={{ mode, setMode }}>
            <CssBaseline enableColorScheme />
            <Box sx={{ overflowX: 'hidden' }}>
                {children}
            </Box>
        </ThemeContext.Provider>
    );
}
